'use strict';

module.exports = (typeof window !== "undefined" ? window['angular'] : typeof global !== "undefined" ? global['angular'] : null)
  .module('animate-change', [])
  .directive('animateChange', require('./directive'))
  .name;
